import { OnSuccessCallback, useCustomMutation } from './index';
import { QueryError, QueryKeys } from '../queries';
import Config from '../../config';
import { METHODS } from '../constants';
import { YesNoFlag } from '../types';
import { Client } from '../../administration/clientPage/types';

export type UpdateMaintenanceModeVariables = {
  clientIds: number[],
  maintenanceFlag: YesNoFlag
}

export const useUpdateMaintenanceMode = (
  onSuccess?: OnSuccessCallback<Response, UpdateMaintenanceModeVariables>
) =>
  useCustomMutation<Response, QueryError, UpdateMaintenanceModeVariables>({
    handleData: (body: UpdateMaintenanceModeVariables) => ({
      url: Config.endpoints.UPDATE_MAINTENANCE_MODE_FOR_MULTIPLE_CLIENTS,
      method: METHODS.PUT,
      body,
    }),
    invalidateKey: QueryKeys.client.ClientList,
    errorMessage: 'Editing Maintenance Mode failed',
    successMessage: 'Maintenance Modes edited successfully',
    onSuccess,
  });

export const useAddClient = (onSuccess?: OnSuccessCallback<Response, Client>) =>
  useCustomMutation<Response, QueryError, Client>({
    handleData: client => ({
      url: Config.endpoints.INSERT_CLIENT,
      method: METHODS.POST,
      body: client,
    }),
    invalidateKey: QueryKeys.client.ClientList,
    errorMessage: 'Creating Client failed',
    successMessage: 'Client created successfully',
    onSuccess,
  });


export const useUpdateClient = (onSuccess?: OnSuccessCallback<Response, Client>) =>
  useCustomMutation<Response, QueryError, Client>({
    handleData: client => ({
      url: Config.endpoints.UPDATE_CLIENT
        .replace(':clientId', String(client.clientId)),
      method: METHODS.PUT,
      body: client,
    }),
    invalidateKey: QueryKeys.client.ClientList,
    errorMessage: 'Updating Client failed',
    successMessage: 'Client updated successfully',
    onSuccess,
  });

export const useRemoveClient = (onSuccess?: OnSuccessCallback<Response, Client>) =>
  useCustomMutation<Response, QueryError, Client>({
    handleData: ({ clientId }) => ({
      url: Config.endpoints.DELETE_CLIENT
        .replace(':clientId', String(clientId)),
      method: METHODS.DELETE,
    }),
    invalidateKey: QueryKeys.client.ClientList,
    errorMessage: 'Removing Client failed',
    successMessage: 'Client removed successfully',
    onSuccess,
  });
